import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.open();
    });
  }

  open() {
    this.element.setAttribute("data-active", true);
  }

  close() {
    this.element.removeAttribute("data-active");
    window.setTimeout(() => {
      this.element.remove();
    }, 1000);
  }
}
